import { StoreonModule } from 'storeon'
import { toast } from 'react-toastify'
import { api } from '@/api'
import { TYPE_USER } from '@/const'
import { Events, State } from '../../interfaces'

export const userModule: StoreonModule<State, Events> = (store) => {
  store.on('@init', () => ({
    currentUser: {
      id: 0,
      avatar: null,
      first_name: '',
      last_name: '',
      patronymic_name: '',
      email: '',
      phone: '',
      source_of_traffic: null,
      autogenerated_tariff: false,
      sex: 1,
      birthday: null,
      is_news_email: false,
      user_status: TYPE_USER.VIEWER,
      status: false,
      wave_user_type: {
        id: 0,
        title: '',
        slug: '',
        is_sport: false
      },
      tube_user_type: {
        id: 0,
        title: '',
        slug: '',
        is_sport: false
      },
      deposit_money: ''
    },
    selectedUser: null,
    depositListUser: {
      deposit_money: 0,
      minute_deposits: [],
      set_deposits: []
    },
    depositListPattern: {
      money_deposits: [],
      tube_deposits: [],
      wave_deposits: {
        tariff_rates: [],
        rent_rates: []
      },
      rent_rates: []
    },
    flagSidebar: true
  }))

  store.on('currentUser/get', async (state, event) => {
    if (event) {
      store.dispatch('currentUser/save', {
        ...event,
        status: true
      })
    } else {
      store.dispatch('currentUser/save', { ...state.currentUser, status: false })
    }
  })

  store.on('currentUser/save', (state, event) => ({ currentUser: event }))

  store.on('selectedUser/set', (state, event) => {
    if (!event) {
      return {
        selectedUser: undefined
      }
    }

    const checkLabel = event.label.split('null').join('')

    return {
      selectedUser: {
        ...event,
        label: checkLabel
      }
    }
  })

  store.on('depositListUser/get', async (state, event) => {
    await api.user
      .getDepositListUser(event)
      .then((response) => {
        store.dispatch('depositListUser/save', response)
      })
      .catch(() => {
        toast.error('Ошибка получения депозитов!')
      })
  })

  store.on('depositListUser/save', (state, event) => {
    return {
      depositListUser: event
    }
  })

  store.on('depositListPattern/get', async (state, event) => {
    await api.tariff
      .getDepositListPattern({
        ...event
      })
      .then((response) => {
        store.dispatch('depositListPattern/save', response)
      })
      .catch(() => {
        toast.error('Ошибка получения депозитов!')
      })
  })

  store.on('depositListPattern/save', (state, event) => {
    return {
      depositListPattern: event
    }
  })

  store.on('changeSidebar', (state, event) => {
    return {
      flagSidebar: event
    }
  })
}
